import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import api from '../../services/api';
import toastError from '../../errors/toastError';

const FlowBuilderMoveKanbanModal = ({ open, onSave, onUpdate, data, close }) => {
  const [kanbans, setKanbans] = useState([]);
  const [kanbanId, setKanbanId] = useState('');

  const isOpen = open === 'create' || open === 'edit';

  useEffect(() => {
    if (!isOpen) return;
    (async () => {
      try {
        // AJUSTAR: use o mesmo endpoint que o modal de Tag/Kanban usa hoje
        const { data: res } = await api.get('/tags/list', {
          params: { kanban: 1 },
        });
        setKanbans(Array.isArray(res) ? res : res.tags || []);
      } catch (err) {
        toastError(err);
      }
    })();
  }, [isOpen]);

  useEffect(() => {
    if (open === 'edit' && data?.data?.kanbanId) {
      setKanbanId(data.data.kanbanId);
    } else if (open === 'create') {
      setKanbanId('');
    }
  }, [open, data]);

  const handleClose = () => close(null);

  const handleSave = () => {
    const selected = kanbans.find((k) => k.id === kanbanId);
    const payload = { kanbanId, kanbanName: selected?.name || '' };

    if (open === 'edit') {
      onUpdate({ ...data, data: { ...data.data, ...payload } });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth='xs'>
      <DialogTitle>Mover para Kanban</DialogTitle>
      <DialogContent>
        <FormControl fullWidth variant='outlined' margin='dense'>
          <InputLabel>Kanban de destino</InputLabel>
          <Select
            value={kanbanId}
            onChange={(e) => setKanbanId(e.target.value)}
            label='Kanban de destino'
          >
            {kanbans.map((k) => (
              <MenuItem key={k.id} value={k.id}>
                {k.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          onClick={handleSave}
          color='primary'
          variant='contained'
          disabled={!kanbanId}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderMoveKanbanModal;